export const VIDEO_CONFIG = {
  videoCodec: 'avc1.42E01E',
  audioCodec: 'mp4a.40.2',
  videoContainer: 'video/mp4',
  recorderOptions: {
    mimeType: 'video/mp4; codecs=avc1.42E01E,mp4a.40.2',
    videoBitsPerSecond: 1_500_000,
    audioBitsPerSecond: 128_000,
  },
};

export const checkMp4Support = () => {
  return MediaRecorder.isTypeSupported(VIDEO_CONFIG.recorderOptions.mimeType);
};

export const VIDEO_STREAM_CONFIG = {
  video: {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    frameRate: { ideal: 24 },
  },
  audio: true,
};
